module.exports = __webpack_public_path__ + "static/img/windows_PATH.1459fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/c/images/windows_PATH.png
// module id = WeYq
// module chunks = 1